import { useRef } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import socialCoinPng from '../../assets/social_coin.png';
import sweepCoinPng from '../../assets/sweep_coin.png';
import { formatValueWithK } from '../../utils/helpers';
import { formatNumber } from '../../utils/numberFormat';
import { useVwToPx } from '../EventTriggerDialog/hooks/useVwToPx';

import classes from './BaroulettaPopupImage.module.scss';
import type { BaroulettaMaxPrize } from './types';

interface Props {
  imageUrl: string;
  coinType?: 'GC' | 'SC';
  amount?: number;
  type?: 'rounds' | 'coins';
  maxWidth?: string | number;
  maxPrize?: BaroulettaMaxPrize;
  displayCount?: number;
}

export default function BaroulettaPopupImage({
  imageUrl,
  type,
  coinType,
  amount,
  maxWidth,
  maxPrize,
  displayCount,
}: Props) {
  const parentRef = useRef<HTMLDivElement>(null);
  const fontSize = useVwToPx({ ref: parentRef, vwValue: 19 });
  const { t } = useTranslation();

  const isNewFormat = maxPrize?.useMeta === true;
  const isCoinsType = maxPrize?.type === 'coins';
  const isOldFormat = maxPrize?.showMaxPrize && isCoinsType && maxPrize.amount && maxPrize.coinType && !isNewFormat;

  const displayAmount = amount ?? (isCoinsType ? maxPrize.amount : undefined);
  const displayCoinType = coinType ?? (isCoinsType ? maxPrize.coinType : undefined);
  const shouldShowMaxPrizeOverlay = isOldFormat && displayAmount;

  const coinIcon = displayCoinType === 'GC' ? socialCoinPng : sweepCoinPng;
  const withCount = displayCount != null && displayCount > 0;

  return (
    <div
      ref={parentRef}
      className={classNames(classes.baroulettaPopupWrapper, withCount && classes.withCount)}
      style={{ fontSize, maxWidth }}
    >
      <img alt="Barouletta Popup" className={classes.baroulettaPopupImage} src={imageUrl} />

      {shouldShowMaxPrizeOverlay && (
        <div
          className={classes.baroulettaPopupText}
          style={{
            top: '67%',
          }}
        >
          {coinIcon && type !== 'rounds' && (
            <img alt="Coin Icon" className={classes.baroulettaPopupCoinIcon} src={coinIcon} />
          )}
          <span>
            {displayAmount === Infinity ? (
              <>&nbsp;∞</>
            ) : displayCoinType === 'GC' && typeof displayAmount === 'number' ? (
              formatValueWithK(displayAmount, t)
            ) : typeof displayAmount === 'number' ? (
              formatNumber(displayAmount)
            ) : null}
          </span>
        </div>
      )}

      {displayCount != null && displayCount > 0 && (
        <div className={classes.displayCount}>
          <span>{formatNumber(displayCount)}</span>
        </div>
      )}
    </div>
  );
}
